export const windowExists = () => {
    return typeof window !== `undefined`
}
